import React from 'react';

export const WorkItemIndex: React.FC<React.PropsWithChildren> = (props) => (
  <div {...props} className="h-10 w-10 flex-shrink-0 rounded bg-[#F2F2F2] text-center font-bold leading-10" />
);
